// extracted by mini-css-extract-plugin
export default {"TableView":"SalesTable_TableView__JxAOf","Cell":"SalesTable_Cell__rut1o","Paper":"SalesTable_Paper__tXnjl"};